module.exports = __webpack_public_path__ + "static/media/live-hero-placeholder-large.b80f7b5a.png";